import { Autocomplete, Box, Input, TextField } from '@mui/material';
import React, { Component } from 'react';

class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.clearSearchBox = this.clearSearchBox.bind(this);
    }

    componentDidMount({ map, mapApi } = this.props) {
        this.searchBox = new mapApi.places.SearchBox(this.searchInput);
        this.searchBox.addListener('places_changed', this.onPlacesChanged);
        this.searchBox.bindTo('bounds', map);
        // si se recibe un valor de ubicacion, renderizar el marcador por defecto
    }

    componentWillUnmount({ mapApi } = this.props) {
        mapApi.event.clearInstanceListeners(this.searchInput);
    }

    onPlacesChanged = ({ map, addplace } = this.props) => {
        const selected = this.searchBox.getPlaces();
        const { 0: place } = selected;
        if (!place.geometry) return;
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);
        }

        addplace(selected);
        this.searchInput.blur();
    };

    clearSearchBox() {
        this.searchInput.value = '';
    }

    render() {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', backgroundColor: 'white' }}>
                <input
                    ref={(ref) => {
                        this.searchInput = ref;
                    }}
                    type="text"
                    onFocus={this.clearSearchBox}
                    placeholder="Buscar en el mapa"
                    style={{
                        width: '100%',
                        minHeight: '30px',
                        fontFamily: 'sans-serif',
                        fontSize: '18px',
                        padding: '12px 16px',
                        border: '1px solid #ced4da',
                        borderRadius: 3,
                        "& :hover": {
                            border_color: '#1976D2'
                        },
                        "& :focus": {
                            border: '#1976D2'
                        },
                        outline: 'none',
                        transition: 'border-color 0.2s',
                        marginBottom: '5px',
                        '.pac-container': {
                            zIndex: '100000 !important'
                        }
                    }}
                //sx={{ borderRadius: '4px', padding: '8px', width: '50%' }}
                />
            </Box>
        );
    }
}

export default SearchBox;